import ExamArticle from './ExamArticle';

export default ExamArticle;
